import { min } from '../utils';

// 整数格式化
export const formatNumber = (num = 0, fixed = 1) => {
  if (num > 100000000) {
    return `${(num / 100000000).toFixed(min(fixed, 8))}亿`;
  } if (num > 10000) {
    return `${(num / 10000).toFixed(min(fixed, 4))}万`;
  }
  return `${(num).toFixed(0)}`;
};

// 浮点数格式化
export const formatFloat = (num = 0, fixed = 1) => {
  if (num > 100000000) {
    return `${(num / 100000000).toFixed(fixed)}亿`;
  } if (num > 10000) {
    return `${(num / 10000).toFixed(fixed)}万`;
  }
  return `${(num).toFixed(fixed)}`;
};

// 距离格式化
export const formatDistance = (num = 0, fixed = 1) => {
  if (num > 1000) {
    return `${(num / 1000).toFixed(fixed)}km`;
  }
  return `${num.toFixed(fixed)}m`;
};
